export enum ServiceStatus {
  CREATED = 1,
  WAITING = 2,
  ASSIGNED = 3,
  IN_PROCESS = 4,
  END = 5,
  CANCELED = 6,
  RELAUNCHED = 8,
  END_FAILED = 10,
}
